import { CURRENT_ROUTE, REQUEST_CURRENT_ROUTE, CREATE_ROUTE, CLOSE_ROUTE, ROUTE_ERROR } from '../actions/route';

import { currentRoute, createRoute } from '../../services/route';

const state = { currentRoute: {}, error: '', status: '' };

const getters = {
  getCurrentRoute: state => state.currentRoute,
}

const actions = {
  [REQUEST_CURRENT_ROUTE]:  ({commit, dispatch}) => {
    commit(REQUEST_CURRENT_ROUTE);
    currentRoute()
    .then( (response) =>{
      commit(CURRENT_ROUTE, response);
    })
    .catch( (err) => {
      commit(ROUTE_ERROR, err);
    });
  },
  [CREATE_ROUTE]: ({commit, dispatch}) => {},
  [CLOSE_ROUTE]: ({commit, dispatch}) => {},
}

const mutations = {
  [REQUEST_CURRENT_ROUTE]: (state) => {
    state.status = 'loading';
  },
  [CURRENT_ROUTE]: (state, resp) => {
    state.status = 'sucess';
    state.currentRoute = resp.data;
  },
  [ROUTE_ERROR]: (state, resp) =>{
    state.status = 'error';
    if (resp.data) {
      state.error = resp.data.message;
    } else if (resp.response.data) {
      state.error = resp.response.data.message;
    } else {
      state.error = 'Error desconocido';
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}